module.exports = __webpack_public_path__ + "img/facilities_on.93e68441.svg";